<template>
  <!-- 我的订单 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="bread">我的订单</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="content">
        <div class="title">我的订单</div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <!-- 精选运价 -->
          <el-tab-pane label="精选运价" name="first">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input
                v-model="jxycForm.order_sn"
                placeholder="订单编号"
              ></el-input>
              <el-select v-model="jxycForm.order_status" placeholder="订单状态">
                <el-option label="全部" value="0"></el-option>
                <el-option label="订舱中" value="1"></el-option>
                <el-option label="已放舱" value="2"></el-option>
                <el-option label="已截单" value="3"></el-option>
                <el-option label="待离港" value="4"></el-option>
                <el-option label="已离港" value="5"></el-option>
                <el-option label="已完成" value="6"></el-option>
                <el-option label="已取消" value="11"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="jxycdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <el-select v-model="jxycForm.pol_id" placeholder="起运港">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn + '-' + item.name_en"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select v-model="jxycForm.pod_id" placeholder="目的港" 
                filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="mdgActiveName">
                  <el-tab-pane
                    :key="index"
                    v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                      :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist"
                    >
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                        :key="adx"
                        :label="at.port_name + '-' + at.name_en"
                        :value="at.port_id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
              <div class="btns">
                <el-button class="chongzhi" @click="jxycChongzhi">重置</el-button>
                <el-button class="shaixuan" @click="jxycSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="jxycTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="order_sn" label="订单编号">
              </el-table-column>
              <el-table-column prop="pol_name" label="起运港">
              </el-table-column>
              <el-table-column prop="pod_name" label="目的港">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column prop="order_status" label="订单状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.order_status == 1">订舱中</span>
                  <span v-if="scope.row.order_status == 2">已放舱</span>
                  <span v-if="scope.row.order_status == 3">已截单</span>
                  <span v-if="scope.row.order_status == 4">待离港</span>
                  <span v-if="scope.row.order_status == 5">已离港</span>
                  <span v-if="scope.row.order_status == 6">已完成</span>
                  <span v-if="scope.row.order_status == 11">已取消</span>
                </template>
              </el-table-column>
              <el-table-column prop="user_liuyan_num" label="未读留言数量">
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <!-- $router.push('/OrderDetails') -->
                  <el-button
                    class="bianji"
                    @click="xiangqing(scope.row)"
                    type="text"
                    size="small"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="jxycForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="jxycForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="jxycTotal"
            >
            </el-pagination>
          </el-tab-pane>
          <!-- 现舱市场 -->
          <el-tab-pane label="现舱市场" name="second">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input
                v-model="xcscForm.order_sn"
                placeholder="订单编号"
              ></el-input>
              <el-select v-model="xcscForm.order_status" placeholder="订单状态">
                <el-option label="全部" value="0"></el-option>
                <el-option label="订舱中" value="1"></el-option>
                <el-option label="已放舱" value="2"></el-option>
                <el-option label="已截单" value="3"></el-option>
                <el-option label="待离港" value="4"></el-option>
                <el-option label="已离港" value="5"></el-option>
                <el-option label="已完成" value="6"></el-option>
                <el-option label="已取消" value="11"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="xcscdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <el-select v-model="xcscForm.pol_id" placeholder="起运港">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn + '-' + item.name_en"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select v-model="xcscForm.pod_id" placeholder="目的港" filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                <!-- @tab-click="handleClick" -->
                <el-tabs class="mudig" v-model="mdgActiveName">
                  <el-tab-pane
                    :key="index"
                    v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                      :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist"
                    >
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                        :key="adx"
                        :label="at.port_name + '-' + at.name_en"
                        :value="at.port_id"
                      >
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
              <div class="btns">
                <el-button class="chongzhi" @click="xcscChongzhi">重置</el-button>
                <el-button class="shaixuan" @click="xcscSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="xcscTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="order_sn" label="订单编号">
              </el-table-column>
              <el-table-column prop="pol_name" label="起运港">
              </el-table-column>
              <el-table-column prop="pod_name" label="目的港">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column prop="order_status" label="订单状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.order_status == 1">订舱中</span>
                  <span v-if="scope.row.order_status == 2">已放舱</span>
                  <span v-if="scope.row.order_status == 3">已截单</span>
                  <span v-if="scope.row.order_status == 4">待离港</span>
                  <span v-if="scope.row.order_status == 5">已离港</span>
                  <span v-if="scope.row.order_status == 6">已完成</span>
                  <span v-if="scope.row.order_status == 11">已取消</span>
                </template>
              </el-table-column>
              <el-table-column prop="user_liuyan_num" label="未读留言数量">
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <!-- $router.push('/OrderDetails') -->
                  <el-button
                    class="bianji"
                    @click="xiangqing(scope.row)"
                    type="text"
                    size="small"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="xcscForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="xcscForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="xcscTotal"
            >
            </el-pagination>
          </el-tab-pane>
          <!-- 船东SPOT -->
          <!-- <el-tab-pane label="船东SPOT" name="third">
            <div class="yi">
              <el-input
                v-model="cdForm.order_sn"
                placeholder="订单编号"
              ></el-input>
              <el-select v-model="cdForm.order_status" placeholder="订单状态">
                <el-option label="全部" value="0"></el-option>
                <el-option label="已下单" value="1"></el-option>
                <el-option label="处理中" value="2"></el-option>
                <el-option label="已完成" value="3"></el-option>
                <el-option label="已取消" value="4"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="cddate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <el-select v-model="cdForm.pol_code" placeholder="起运港">
                <el-option
                  v-for="item in qiYGTitleList"
                  :key="item.id"
                  :label="item.name_cn + '-' + item.name_en"
                  :value="item.code"
                >
                </el-option>
              </el-select>
              <el-select v-model="cdForm.pod_code" placeholder="目的港" filterable 
                remote
                reserve-keyword
                :remote-method="mdgremoteMethod"
                :loading="mdgloading">
                <el-tabs class="mudig" v-model="mdgActiveName">
                  <el-tab-pane
                    :key="index"
                    v-for="(item,index) in muDgList"
                    :label="item.route_name"
                    :name="item.route_name"
                  >
                    <el-option-group
                      v-for="(it,idx) in item.tag_arr"
                      :key="idx"
                      :label="it.tag_name"
                      :value="it.tag_id"
                      class="mdglist"
                    >
                      <el-option
                        v-for="(at,adx) in it.port_arr"
                        :key="adx"
                        :label="at.port_name + '-' + at.name_en"
                        :value="at.code"
                      >
                      </el-option>
                    </el-option-group>
                  </el-tab-pane>
                </el-tabs>
              </el-select>
              <div class="btns">
                <el-button class="chongzhi" @click="cdChongzhi">重置</el-button>
                <el-button class="shaixuan" @click="cdSearch">筛选</el-button>
              </div>
            </div>

            <el-table
              v-loading="tableLoading"
              :data="cdTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="order_sn" label="订单编号">
              </el-table-column>
              <el-table-column prop="pol_name" label="起运港">
              </el-table-column>
              <el-table-column prop="pod_name" label="目的港">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column prop="order_status" label="订单状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.order_status==1">已下单</span>
                  <span v-if="scope.row.order_status==2">处理中</span>
                  <span v-if="scope.row.order_status==3">已完成</span>
                  <span v-if="scope.row.order_status==4">已取消</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button
                    class="bianji"
                    @click="xiangqing(scope.row)"
                    type="text"
                    size="small"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="cdTotal"
            >
            </el-pagination>
          </el-tab-pane> -->
          <!-- 美加到门 -->
          <el-tab-pane label="美加到门" name="fourth">
            <!-- 筛选条件 -->
            <div class="yi">
              <el-input v-model="mjdmForm.order_sn" placeholder="订单编号"></el-input>
              <el-select v-model="mjdmForm.type" placeholder="进出口">
                <el-option label="全部" value=""></el-option>
                <el-option label="出口" value="1"></el-option>
                <el-option label="进口" value="2"></el-option>
              </el-select>
              <el-select v-model="mjdmForm.status" placeholder="订单状态">
                <el-option label="全部" value="0"></el-option>
                <el-option label="已下单" value="1"></el-option>
                <el-option label="处理中" value="2"></el-option>
                <el-option label="已完成" value="3"></el-option>
                <el-option label="已取消" value="4"></el-option>
              </el-select>
              <el-select
                @change="getPortList"
                v-model="mjdmForm.country_id"
                clearable
                filterable
                placeholder="下单国家"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <!-- <el-select
                v-model="mjdmForm.state_port_id"
                clearable
                filterable
                placeholder="起运港ID | 卸货港ID"
              >
                <el-option
                  v-for="item in statePortList"
                  :key="item.id"
                  :label="item.port + '-' + item.port_english"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
              <el-select
                @change="getfujinPort"
                v-model="mjdmForm.end_city_id"
                clearable
                filterable
                placeholder="送达城市(邮编) | 起运城市(邮编)"
                remote
                reserve-keyword
                :remote-method="zipCodeRemoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in endPortList"
                  :key="item.id"
                  :label="item.place_name + '(' + item.postal_code + ')'"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="mjdmForm.port_id"
                clearable
                filterable
                placeholder="卸货港、卸货地 | 装货港、装货地"
              >
                <el-option
                  v-for="item in portList"
                  :key="item.id"
                  :label="item.port"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="mjdmdate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>

              <div class="btns">
                <el-button class="chongzhi" @click="mjdmChongzhi">重置</el-button>
                <el-button class="shaixuan" @click="mjdmSearch">筛选</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table
              v-loading="tableLoading"
              :data="mjdmTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f9f9f9' }"
            >
              <el-table-column prop="order_sn" label="订单编号">
              </el-table-column>
              <el-table-column prop="type_desc" label="下单类型">
              </el-table-column>
              <el-table-column prop="country_name" label="国家">
              </el-table-column>
              <el-table-column prop="port_name" label="卸货港/卸货地">
              </el-table-column>
              <el-table-column prop="end_city_name" label="送达城市(邮编)">
              </el-table-column>
                <el-table-column prop="status_desc" label="订单状态"></el-table-column>
              <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                  <!-- $router.push('/USToDoorOrderDetails') -->
                  <el-button
                    class="bianji"
                    @click="xiangqing(scope.row)"
                    type="text"
                    size="small"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="mjdmForm.page_no"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="mjdmForm.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="mjdmTotal"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <Bottom />
  </div>
</template>
    
<script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import {
  basePortValidList,
  destinationPortRouteTypeValidList,
  getPortByCountries,
  getCityList,
  getPortByCityId,
  myOrdersLists,
  myOrderList,
  shipOrderList,
} from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      activeName: "first",
      headers: {
        token: localStorage.getItem("token"),
      },
      // 起运港列表
      qiYGTitleList: [],
      muDgList: [],
      mdgloading:false,
      mdgActiveName: "",
      currentPage: 1,
      jxycTableData: [],
      jxycTotal: 0,
      jxycForm: {
        order_type: 1,
        page_no: 1,
        page_size: 10,
        order_sn: "",
        order_status: "",
        pol_id: "",
        pod_id: "",
        state_time: "",
        end_time: "",
      },
      jxycdate: "",
      xcscTableData: [],
      xcscTotal: 0,
      xcscForm: {
        order_type: 2,
        page_no: 1,
        page_size: 10,
        order_sn: "",
        order_status: "",
        pol_id: "",
        pod_id: "",
        state_time: "",
        end_time: "",
      },
      xcscdate: "",
      cdTableData: [],
      cdTotal: 0,
      cdForm: {
        order_sn: "",
        order_status: "",
        pol_code:'',
        pod_code: "",
        state_time: "",
        end_time: "",
        page_no: 1,
        page_size: 10,
      },
      cddate:'',
      mjdmTableData: [],
      mjdmTotal: 0,
      mjdmForm: {
        type:'', // 进出口：1出口、2进口
        order_sn:'',
        country_id:'', // 国家id
        state_port_id:'', // 起运港ID | 卸货港ID
        end_city_id:'',  // 送达城市ID | 起运城市ID
        port_id:'', // 卸货港、卸货地ID | 装货港、装货地ID
        state_time:'',
        end_time:'',
        status:'',
        page_no: 1,
        page_size: 10,
      },
      mjdmdate:'',
        statePortList:[], //美加到门起运港
        endPortList:[], // 美加到门送达城市
        portList:[], // 美加到门卸货港卸货地
      // 国家
      countryList: [
        {
          "id": 6,
          "name": "美国"
        },
        {
          "id": 7,
          "name": "加拿大"
        }
      ],
      loading:false,
      tableLoading:false,
    };
  },
  methods: {
    handleClick() {
      this.mdgActiveName = this.muDgList[0].route_name;
      if (this.activeName == "first") {
        this.getJxyjList();
      } else if (this.activeName == "second") {
        this.getXcscList();
      } else if (this.activeName == "third") {
        this.getCdList()
      } else if (this.activeName == "fourth") {
        this.getMjdmList();
      }
      this.getMdgList()
    },
    handleSizeChange(val) {
      if (this.activeName == "first") {
        this.jxycForm.page_size=val
        this.getJxyjList();
      } else if (this.activeName == "second") {
        this.xcscForm.page_size=val
        this.getXcscList();
      } else if (this.activeName == "third") {
        this.cdForm.page_size=val
        this.getCdList();
      } else if (this.activeName == "fourth") {
        this.mjdmForm.page_size=val
        this.getMjdmList();
      }
    },
    handleCurrentChange(val) {
        if (this.activeName == "first") {
        this.jxycForm.page_no=val
        this.getJxyjList();
      } else if (this.activeName == "second") {
        this.xcscForm.page_no=val
        this.getXcscList();
      } else if (this.activeName == "third") {
        this.cdForm.page_no=val
        this.getCdList();
      } else if (this.activeName == "fourth") {
        this.mjdmForm.page_no=val
        this.getMjdmList();
      }
    },
    async getMjdmList() {
      this.tableLoading = true
      try {
        const res = await myOrdersLists(this.mjdmForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.mjdmTableData = res.data.lists;
          this.mjdmTotal = res.data.count;
        }else{
          this.tableLoading = false
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    async getJxyjList() {
      this.tableLoading = true
      try {
        const res = await myOrderList(this.jxycForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.jxycTableData = res.data.lists;
          this.jxycTotal = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    async getXcscList() {
      this.tableLoading = true
      try {
        const res = await myOrderList(this.xcscForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.xcscTableData = res.data.lists;
          this.xcscTotal = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    async getCdList() {
      this.tableLoading = true
      try {
        const res = await shipOrderList(this.cdForm, this.headers);
        if (res.code == 1) {
          this.tableLoading = false
          this.cdTableData = res.data.lists;
          this.cdTotal = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 详情
    xiangqing(e) {
      let url = "OrderDetails";
      if (this.activeName == "first") {
        url = "OrderDetails";
      } else if (this.activeName == "second") {
        url = "MarketOrderDetails";
      } else if (this.activeName == "third") {
        url = "ShipSPOTOrderDetails";
      } else if (this.activeName == "fourth") {
        url = "USToDoorOrderDetails";
      }
      let param = {
        id: e.id,
      };
      this.$router.push({
        name: url,
        params: param,
        query: param
      });
    },
    // 起运港
    async getQygList() {
      // 起运港列表
      let basePortParams = {
        page_no: 1,
        page_size: 50,
        keyword: "",
      };
      const basePortRes = await basePortValidList(basePortParams);
      if (basePortRes.code == 1) {
        this.qiYGTitleList = basePortRes.data.lists;
      }
    },
    // 目的港
    async getMdgList(e) {
        this.mdgloading = true;
        if(e==undefined){
          e=''
        }
        // 目的港列表
        const res = await destinationPortRouteTypeValidList({
            keyword:e
          });
        if (res.code==1) {
          this.muDgList=res.data
          if(res.data.length>0){
            this.mdgActiveName=res.data[0].route_name
          }
          this.mdgloading = false
          // mdgloading:false,
        }
      },
      mdgremoteMethod(query){
        if (query !== '') {
          setTimeout(async () => {
            this.getMdgList(query)
          }, 200);
        } else {
          this.getMdgList();
        }
      },
    // 筛选
    jxycSearch() {
      if(this.jxycdate!=''){
        this.jxycForm.state_time = this.jxycdate[0];
        this.jxycForm.end_time = this.jxycdate[1];
      }
      
      this.getJxyjList();
    },
    xcscSearch() {
      if(this.xcscdate!=''){
        this.xcscForm.state_time = this.xcscdate[0];
        this.xcscForm.end_time = this.xcscdate[1];
      }
      
      this.getXcscList();
    },
    cdSearch() {
      if(this.cddate!=''){
        this.cdForm.state_time = this.cddate[0];
        this.cdForm.end_time = this.cddate[1];
      }
      
      this.getCdList();
    },
    mjdmSearch() {
      if(this.mjdmdate!=''){
        this.mjdmForm.state_time = this.mjdmdate[0];
        this.mjdmForm.end_time = this.mjdmdate[1];
      }
      
      this.getMjdmList();
    },
    // 重置
    jxycChongzhi() {
      this.jxycForm={
        order_type: 1,
        page_no: 1,
        page_size: 10,
        order_sn: "",
        order_status: "",
        pol_id: "",
        pod_id: "",
        state_time: "",
        end_time: "",
      }
      this.jxycdate=''
      this.getJxyjList();
    },
    xcscChongzhi() {
      this.xcscForm={
        order_type: 2,
        page_no: 1,
        page_size: 10,
        order_sn: "",
        order_status: "",
        pol_id: "",
        pod_id: "",
        state_time: "",
        end_time: "",
      }
      this.xcscdate=''
      this.getXcscList();
    },
    cdChongzhi() {
      this.cdForm={
        order_sn: "",
        order_status: "",
        pol_id:'',
        pod_id: "",
        state_time: "",
        end_time: "",
        page_no: 1,
        page_size: 10,
      }
      this.cddate=''
      this.getCdList();
    },
    mjdmChongzhi() {
      this.mjdmForm={
        type:'', // 进出口：1出口、2进口
        order_sn:'',
        country_id:'', // 国家id
        state_port_id:'', // 起运港ID | 卸货港ID
        end_city_id:'',  // 送达城市ID | 起运城市ID
        port_id:'', // 卸货港、卸货地ID | 装货港、装货地ID
        state_time:'',
        end_time:'',
        status:'',
        page_no: 1,
        page_size: 10,
      }
      this.mjdmdate=''
      this.getMjdmList();
    },
    // 美加到门  起运港
    async getPortList() {
      let params = {
        page_no: 1,
        page_size: 10,
        countries_id: this.mjdmForm.country_id,
      };
      const res = await getPortByCountries(params);
      console.log(res, "获取列表");
      if (res.code == 1) {
        this.statePortList = res.data.lists;
      }
    },
    // 美加到门 城市邮编
    async getZipCodeList() {
      // if(this.mjdmForm.end_city_id!=''){
      let params = {
        page_no: 1,
        page_size: 10,
        countries_id: this.mjdmForm.country_id,
        keyword: this.mjdmForm.end_city_id,
      };
      const res = await getCityList(params);
      if (res.code == 1) {
        this.endPortList = res.data.lists;
      }
    },
    // 城市邮编 远程搜索
    zipCodeRemoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.getZipCodeList();
        }, 200);
      } else {
        this.endPortList = [];
      }
    },
    // 获取附近港口
    async getfujinPort() {
      this.mjdmForm.port_id = "";
      let params = {
        page_no: 1,
        page_size: 10,
        countries_id: this.mjdmForm.country_id,
        end_city_id: this.mjdmForm.end_city_id,
      };
      const res = await getPortByCityId(params);
      if (res.code == 1) {
        this.portList = res.data.lists;
      }
    },
  },
  mounted() {
    this.getJxyjList();
    this.getQygList();
    this.getMdgList();
  },
};
</script>
    
<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.content {
  border-radius: 12px 12px 12px 12px;
  background: #fff;

  margin-bottom: 32px;

  padding: 32px;

  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 10px;
  }

  ::v-deep .el-tabs__item.is-active {
    color: #0073f5; //选中
  }

  ::v-deep .el-tabs__item:hover {
    color: #0073f5; //hover
    // cursor: pointer;
  }
  // 普通字体颜色
  ::v-deep .el-tabs__item {
    color: #606260; //悬浮
    // cursor: pointer;
    font-size: 18px;
  }

  // 下划线颜色
  ::v-deep .el-tabs__active-bar {
    background-color: #0073f5;
  }

  .yi {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    margin-top: 4px;

    .btns {
      width: 360px;
      height: 40px;
      text-align: right;

      .chongzhi {
        width: 100px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        font-style: normal;
        text-transform: none;
      }

      .shaixuan {
        width: 100px;
        height: 40px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        border: 0;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #fff;
        font-style: normal;
        text-transform: none;
      }
    }

    :deep(.el-input) {
      width: 360px;
      height: 40px;
      margin-bottom: 16px;

      input {
        width: 360px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;

        border: 0;
      }
    }
    :deep(.el-date-editor) {
      width: 360px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      margin-bottom: 16px;

      .el-range-input {
        background: #f9f9f9;
      }
    }
  }

  .table {
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;

    margin-top: 4px;

    .theader {
      height: 48px;
      background: #f9f9f9;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }
    .first {
      padding-left: 24px;
      // width: 320px;
    }
    .tbody {
      height: 68px;
      background: #fff;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      font-style: normal;
      text-transform: none;
    }
  }

  .el-pagination {
    text-align: right;
    margin-top: 80px;
  }
}

.mudig {
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  width: 500px;
  .mdglist {
    :deep(.el-select-group) {
      display: flex;
      flex-wrap: wrap;
    }
  }
  :deep(.el-select) {
    ul.el-select-group {
      display: flex;
    }
  }
}
</style>